import { Moment } from 'moment';
import { momentForDomain } from '@common/services/moment-shadow';

import { HourEntryFragment } from '@common/graphql/schema';

const moment = momentForDomain('timekeeping', 'timesheet');

export const parseInTz = (date: string, tz?: string | null): Moment => {
  let parsed = moment.parseZone(date);
  if (tz) {
    parsed = parsed.tz(tz);
  }

  return parsed;
};

export const maybeParseInTz = (
  date: string | undefined | null,
  tz?: string | null
): Moment | undefined => {
  if (!date) {
    return;
  }

  return parseInTz(date, tz);
};

export const parseHourEntryDates = (entry: HourEntryFragment) =>
  [
    parseInTz(entry.startedAt!, entry.startedAtTz),
    parseInTz(entry.endedAt!, entry.endedAtTz),
  ] as const;

export const withMinutesPrecision = (date: Moment | undefined) =>
  date?.seconds(0)?.milliseconds(0);
